import {
  VisWorkOrderStatus,
  VisWorkOrderType,
} from '@lib/kysely/visual/tables/work-order';
import { WorkOrderStatus, WorkOrderType } from '@snap-types/models/enums';

export const workOrderTypeToVisualMap = {
  [WorkOrderType.QUOTE]: VisWorkOrderType.QUOTE,
  [WorkOrderType.WORK_ORDER]: VisWorkOrderType.WORK_ORDER,
  [WorkOrderType.ENGINEERING_MASTER]: VisWorkOrderType.MASTER,
} as const satisfies Record<WorkOrderType, VisWorkOrderType>;

export const workOrderStatusToVisualMap = {
  [WorkOrderStatus.UNRELEASED]: VisWorkOrderStatus.UNRELEASED,
  [WorkOrderStatus.RELEASED]: VisWorkOrderStatus.RELEASED,
  [WorkOrderStatus.CLOSED]: VisWorkOrderStatus.CLOSED,
  [WorkOrderStatus.FIRMED]: VisWorkOrderStatus.FIRMED,
  [WorkOrderStatus.CANCELLED]: VisWorkOrderStatus.CANCELLED,
} as const satisfies Record<WorkOrderStatus, VisWorkOrderStatus>;
